module.exports = __webpack_public_path__ + "img/00018.7ccb7740.webp";